// extracted by mini-css-extract-plugin
module.exports = {"info-video":"styles_info-video__37hhO","info-video__icon":"styles_info-video__icon__Vpp64","slick-height":"styles_slick-height__3R5ip"};